(function () {
  const modifyGorgiasOrders = (http) => {
    const condition =
      http._method == "get" &&
      http._url.startsWith("/apps/gorgias/ssp/orders") &&
      http.status == 200 &&
      http.response.length > 0;
    if (
      !(
        http._method == "get" &&
        http._url.startsWith("/apps/gorgias/ssp/orders") &&
        http.status == 200 &&
        http.response.length > 0
      )
    )
      return;
    const response = JSON.parse(http.response);
    const { orders } = response;
    const orderKeys = Object.keys(orders);
    const filterLineItems = (lineItems) => {
      const newLineItems = [];
      lineItems.forEach((li) => {
        if (li.name.toLowerCase().indexOf("build a system part") != -1) return;
        if (li.name.toLowerCase().indexOf("system items") != -1) return;
        // li.price_set = undefined;
        // li.quantity = undefined;
        // li.refunded_quantity = undefined;
        li.name = li.name.replace(/shadow/i, "").trim();
        newLineItems.push(li);
      });
      return newLineItems;
    };
    orderKeys.forEach((key) => {
      const order = orders[key];
      order.line_items = filterLineItems(order.line_items);
      if (order.fulfillments.length > 0) {
        order.fulfillments.forEach((fulfillment) => {
          fulfillment.line_items = filterLineItems(fulfillment.line_items);
        });
      }
    });
    return JSON.stringify(response);
  };

  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function () {
    // console.log(this);
    this.addEventListener("load", function () {
      const newResponse = modifyGorgiasOrders(this);
      if (newResponse) {
        console.log("GORGIAS before", JSON.parse(this.response));
        Object.defineProperty(this, "response", { writable: true });
        Object.defineProperty(this, "responseText", { writable: true });
        this.response = newResponse;
        this.responseText = newResponse;
        console.log("GORGIAS after", JSON.parse(this.response));
      }
    });
    origOpen.apply(this, arguments);
  };

  const initGorgiasChatPromise = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener("gorgias-widget-loaded", function () {
          resolve();
        });
      });
  initGorgiasChatPromise.then(async () => {
    // custom code
    await new Promise((resolve) => setTimeout(resolve, 1000));
    gorgiasHead = document
      .getElementById("chat-window")
      .contentWindow.document.getElementsByTagName("head")[0];
    const style = document.createElement("style");
    style.textContent = ".line-item__details p.card-text { display: none; }";
    gorgiasHead.append(style);
  });
})();
